/** @jsxImportSource @emotion/react */

import { useLazyQuery } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { FC, useEffect, useState } from 'react'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import {
  findAllCheatSheetGroup,
  findAllCheatSheetGroup_findAllCheatSheetGroup_items as IGroup,
  findAllCheatSheetGroupVariables,
} from '__generatedTypes__/findAllCheatSheetGroup'
import { ClassroomTabEnum } from '__generatedTypes__/globalTypes'
import { FIND_ALL_CHEAT_SHEET_GROUP } from 'queries/cheatSheetGroup'
import { usePlatformsAndSubjects, Props as UsePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { SubjectTabs } from 'components/SubjectsTabs'
import CheatSheetsContent from './CheatSheetsContent'
import * as classes from './styles'

const platformsAndSubjectsProps: UsePlatformsAndSubjects = {
  filterSubjects: (subject) => !!subject.classroomTab.find(({ tabEnum }) => tabEnum === ClassroomTabEnum.CheatSheets),
}

const CheatSheets: FC = () => {
  const { subjects, selectedSubject, selectSubject } = usePlatformsAndSubjects(platformsAndSubjectsProps)
  const [groups, setGroups] = useState<IGroup[]>([])

  const [getGroups, { data: groupsData }] = useLazyQuery<findAllCheatSheetGroup, findAllCheatSheetGroupVariables>(
    FIND_ALL_CHEAT_SHEET_GROUP
  )

  useEffect(() => {
    selectedSubject &&
      getGroups({
        variables: {
          query: {
            take: TAKE_ALL_ITEMS_COUNT,
            where: {
              subject: {
                id: selectedSubject.id,
              },
            },
          },
        },
      })
  }, [selectedSubject])

  useEffect(() => {
    groupsData && setGroups(groupsData?.findAllCheatSheetGroup.items || [])
  }, [groupsData])

  if (!selectedSubject) {
    return null
  }

  return (
    <div css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Cheat Sheets
      </Typography>
      <SubjectTabs subjects={subjects} selectedSubject={selectedSubject} selectSubject={selectSubject} />
      <CheatSheetsContent groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    </div>
  )
}

export default CheatSheets
